<template>
	<div class="box" style="">
		<div style="height: 100%;display: flex;flex-direction: column;justify-content: space-between;">
			<div
				style="display: flex;justify-content: center;align-items: center;font-size: 25px;font-weight: bold;height: 25vh;">
				<div style="display: flex;align-items: center;">
					<el-avatar style="width: 60px;height: 60px;" :src="logo">
					</el-avatar>
					<div style="color: #409EFF;;">
						喀什美之旅租车
					</div>
				</div>
			</div>
			<div
				style="background: linear-gradient(-125deg, #57bdbf, #2f9de2);display: grid;grid-template-columns: 1fr 1fr;height: 50vh;">
				<div>
				</div>
				<div style="display: flex;justify-content: center;align-items: center;">
					<el-card shadow="always" style="width: 50%;box-shadow: 20px 20px 20px  #555F70;">
						<div style="text-align: center;margin-bottom: 20px;font-size: 20px;font-weight: bold;color: #303133;">管理员后台登录
						</div>
						<el-form ref="form" :rules="rules" :model="form" label-width="80px"
							@keyup.enter.native="submit()">
							<el-form-item label="用户名" prop="admin_tel">
								<el-input v-model="form.admin_tel"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="admin_password">
								<el-input type="password" v-model="form.admin_password"></el-input>
							</el-form-item>
							<div>
								<el-button style="width: 100%;" type="primary" @click="submit">登录</el-button>
							</div>
						</el-form>
						
					</el-card>
				</div>
			</div>
			<div style="width: 100%;text-align: center;font-size: 18px;height: 25vh;display: flex;align-items: center;justify-content: center;color: #909399;">
				<div>
					新ICP备案 2020001434号
				</div>
				<div style="margin: 0 20px;">
					
					喀什美之旅旅游客运有限公司
				</div>
				<div>
					欢迎合作
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var admin_tel = (rule, value, callback) => {
				if (value == '') {
					return callback(new Error('请输入用户名'));
				}
			};
			var admin_password = (rule, value, callback) => {
				if (value == '') {
					return callback(new Error('请输入密码'));
				}
			};
			return {
				logo: require('../assets/logo512x512.png'),
				form: {
					admin_tel: '',
					admin_password: ''
				},
				rules: {
					admin_tel: [{
						validator: admin_tel,
						trigger: 'blur'
					}],
					admin_password: [{
						validator: admin_password,
						trigger: 'blur'
					}]
				}
			};
		},
		methods: {
			submit() {
				var sub = true;
				var that = this;
				this.$refs['form'].validate((valid) => {
					sub = false;
				});
				if (!sub) {
					return;
				}
				this.$axios.post('zuche/admin/login', that.form).then(function(res) {
					if (res.data.success) {
						localStorage.setItem('user', JSON.stringify(res.data.result.user));
						that.$router.push('/');
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		},
		mounted() {
			// this.submit();
		}
	};
</script>

<style>
	.box {
		/* background-color: rgb(69, 137, 148); */
		/* background-color: rgb(56, 116, 246);; */
		background-color: white;
		/* border: solid red 1px; */
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue